var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10468 14.4202L3.04036 19.01C2.90171 19.6309 3.12515 20.2728 3.63585 20.658C3.92312 20.8827 4.26326 21 4.61437 21C4.86972 21 5.12508 20.9358 5.36945 20.8074L20.0953 13.008C20.6489 12.7081 21 12.1304 21 11.4995C21 10.8686 20.6489 10.2909 20.0953 9.99094L5.3715 2.19152C4.80693 1.89161 4.13663 1.94579 3.63687 2.34097C3.12616 2.72613 2.90272 3.36806 3.04138 3.98893L4.1057 8.57871C4.32914 9.5416 5.01043 10.323 5.91413 10.676L14.5 11.4995L5.91413 12.324C5.0094 12.676 4.32812 13.4574 4.10468 14.4202Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.891911e450781ee61c20647e98de983d.svg";
export { ForwardRef as ReactComponent };